/*=========================================================================================
  File Name: moduleSmsActions.js
  Description: SMS Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';

export default {
  //Get SMS templeate all datas
  async GetSMSTempate() {
    return new Promise((resolve, reject) => {
      axios
        .get(`sms-nofification-template/`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  //Create new template
  async CreateTempleate({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post('sms-nofification-template/', Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  //update previus templates
  async UpdateTempleate({}, Credentials) {
    return new Promise((resolve, reject) => {
      let ID = Credentials.id;
      delete Credentials.id;

      axios
        .patch(`sms-nofification-template/${ID}`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  //single and bulk sms send
  async SendSingleandBulkSMS({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(`sms-service`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  //Search all templates
  async searchTemplate() {
    return new Promise((resolve, reject) => {
      axios
        .get(`sms-nofification-template/search`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  //Get user,customer and supplier mobile numbers
  async GetPhoneNumbers({}, type) {
    return new Promise((resolve, reject) => {
      axios
        .get(`sms-nofification-template/phonenumber?sendtype=${type}`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  //Allow View Website
  async AllowViewWebsite({}, Credentials) {
    let id = Credentials.id;
    delete Credentials.id;
    return new Promise((resolve, reject) => {
      axios
        .patch(`reviews/${id}/allow-view`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
